import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import axios from "axios";
import FAQ from "../components/Faq";
import contactData from "../json/contact.json";
import CounselingFormModal from "../components/CounselingFormModal";
const BASE_URI = process.env.REACT_APP_API_BASE_URI;
export const Contact = () => {
  const [contactContent, setContactContent] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [faqsLoading, setFaqsLoading] = useState(true);
  const [faqsError, setFaqsError] = useState("");
  const [showModal, setShowModal] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    document.title = contactData.title;
    AOS.init({ duration: 800, once: false });
    setContactContent(contactData);
    fetchFaqs();
  }, []);
  const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  };

  const fetchFaqs = async () => {
    try {
      setFaqsLoading(true);
      const res = await axios.get(
        `${BASE_URI}/entities?category=faq`,
        getAuthHeaders(),
      );

      if (res.data && res.data.data) {
        const transformedData = res.data.data.map((item) => ({
          id: item.id,
          question: item.data.question,
          answer: item.data.answer,
        }));

        setFaqs(transformedData);
      }
      setFaqsError("");
    } catch (err) {
      console.error("Error fetching FAQs", err);
      setFaqsError("Failed to load FAQs");

      setFaqs(contactData.faqSection.faqs);
    } finally {
      setFaqsLoading(false);
    }
  };

  const FAQSkeleton = () => (
    <div style={{ marginBottom: "20px" }}>
      <div
        style={{
          width: "100%",
          height: "60px",
          backgroundColor: "#f0f0f0",
          borderRadius: "8px",
          marginBottom: "10px",
          background:
            "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
          backgroundSize: "200% 100%",
          animation: "shimmer 1.5s infinite",
          display: "flex",
          alignItems: "center",
          padding: "0 20px",
        }}
      >
        <div
          style={{
            width: "80%",
            height: "20px",
            backgroundColor: "#e0e0e0",
            borderRadius: "4px",
          }}
        />
      </div>
    </div>
  );

  if (!contactContent) return null;

  return (
    <>
      <style>
        {`
          @keyframes shimmer {
            0% {
              background-position: -200% 0;
            }
            100% {
              background-position: 200% 0;
            }
          }
        `}
      </style>

      {/* Contact Banner Section */}
      <section className="contact-banner">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 contact-banner-image">
              <div className="left-image">
                <div className="img-box1">
                  <img
                    src={contactContent.contactSection.images.img1}
                    alt="Contact 1"
                  />
                </div>
                <div className="contact-cube"></div>
              </div>
              <div className="right-image">
                <div className="contact-cube2"></div>
                <div className="img-box2">
                  <img
                    src={contactContent.contactSection.images.img2}
                    alt="Contact 2"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 contact-banner-form d-flex justify-content-center align-items-center">
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  paddingBottom: "56.25%",
                }}
              >
                <iframe
                  title="Smart Scholar Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3563.7136248055244!2d88.4271133!3d26.7215943!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39e441c650e70053%3A0x608e7d8df8d90545!2sSmart%20Scholars%20360!5e0!3m2!1sen!2sin!4v1754302247962!5m2!1sen!2sin"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: 0,
                    borderRadius: "12px",
                  }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
          <div className="numbers text-center mt-5 container">
            <div className="row justify-content-center">
              {contactContent.contactSection.contactInfo.map((info, index) => (
                <div
                  className="col-12 col-md-4 d-flex justify-content-center mb-4"
                  key={index}
                >
                  <div className="number-box text-center p-3">
                    <p className="digit">
                      <i className={info.icon}></i>
                    </p>
                    <span>{info.text}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="contactPage-faq">
        <div className="container">
          <div className="col">
            <div className="contactPage-faq-heading">
              <p>{contactContent.faqSection.heading}</p>
              <h2>{contactContent.faqSection.subHeading}</h2>
            </div>
          </div>
          {faqsError && (
            <div className="col">
              <div className="alert alert-warning" role="alert">
                {faqsError} - Showing default FAQs
              </div>
            </div>
          )}
          <div className="col m-5 remove_magin">
            {faqsLoading ? (
              <div>
                {Array.from({ length: 5 }).map((_, index) => (
                  <FAQSkeleton key={index} />
                ))}
              </div>
            ) : (
              <FAQ faqs={faqs} icons={contactContent.faqSection.icons} />
            )}
          </div>
        </div>
      </section>

      {/* Free Counseling Section */}
      <section className="book-free-counseling">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="bfc-top d-flex justify-content-center">
                <div className="image-container">
                  <div className="logo-cont">
                    <i className="bi bi-telephone"></i>
                  </div>
                  <div className="image">
                    <img
                      src={contactContent.counselingSection.image}
                      alt="Counseling"
                    />
                  </div>
                </div>
              </div>
              <div className="bfc-heading mt-4 text-center">
                <h2
                  dangerouslySetInnerHTML={{
                    __html: contactContent.counselingSection.heading,
                  }}
                ></h2>
              </div>
              <div className="bfc-supporting-text mt-3 text-center">
                <p>{contactContent.counselingSection.text}</p>
              </div>
              <div className="bfc-buttons text-center mt-5">
                <button
                  type="button"
                  className="btn btn-primary bfc-btn"
                  onClick={() => setShowModal(true)}
                >
                  {contactContent.counselingSection.button}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CounselingFormModal
        open={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};
